module.exports = __webpack_public_path__ + "infocentrum.jpg?c0a0164ec5454b10c04312129aacfa7e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum.jpg
// module id = 252
// module chunks = 0